import { updateChargingStation } from '@infuse/api/e-connector/charging-station';
import { useNotify } from '@infuse/cpms/ui';
import { ChargingStation, mapToApi } from '@infuse/e-connector/charging-station/domain';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useUpdateChargingStation = () => {
  const queryClient = useQueryClient();
  const { notifySuccess, notifyFailure } = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  return useMutation({
    mutationFn: (chargingStation: ChargingStation) => {
      const apiChargingStation = mapToApi(chargingStation);
      return updateChargingStation({ id: apiChargingStation.id }, apiChargingStation);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['charging-stations'] });

      notifySuccess({
        title: t('e_connector.common.notify.success'),
        message: t('e_connector.chargingStations.notify.update.success')
      });
    },
    onError: (error) => {
      notifyFailure({
        title: t('e_connector.common.notify.error'),
        message: t('e_connector.chargingStations.notify.update.error', {
          reason: getAxiosErrorMessage(error, '')
        })
      });
    }
  });
};
